export default "__VITE_ASSET__BrZl7W8B__"